// SchemaMarkup.jsx - Schema.org is now centralized in public/index.html
// This component is intentionally empty to avoid duplicate LocalBusiness schemas
export default function SchemaMarkup() {
  return null;
}
